Vue.component("stock-manage-component", require("./Create.vue").default);
Vue.component("stock-list-component", require("./Index.vue").default);
Vue.component("stock-report-componet", require("./Report.vue").default);